<template>
  <div 
    class="auth-questions"
    :class="{
      'auth-questions--ac': ac,
      'auth-questions--expired': (timer === 0)
    }"
  >
    <div class="auth-questions__timer">
      <p class="auth-questions__timer__display">Você tem {{timerFormatted}} para responder</p>
    </div>
    <div class="auth-questions__paginator">
      <p class="auth-questions__paginator__display">{{step}}/{{steps}}</p>
    </div>
    <div class="auth-questions__form">
      <p class="auth-questions__form__question">{{question}}</p>
      <div v-if="options" class="auth-questions__form__options">
        <div
          v-for="option in options"
          :key="option.value"
          class="auth-questions__form__options__item"
        >
          <radio-button
            name="auth-options"
            :label="option.label"
            :value="option.value"
            v-model="radioAnswer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import RadioButton from '@/components/form/RadioButton'

  export default {
    model: {
      prop: 'answer',
      event: 'change'
    },
    components: {
      RadioButton
    },
    props: {
      steps: {
        type: Number,
        required: true
      },
      step: {
        type: Number,
        required: true
      },
      timer: {
        type: Number,
        required: true
      },
      question: {
        type: String,
        required: true
      },
      options: {
        type: Array,
        required: true
      },
      answer: {
        type: String,
        default: ''
      }
    },
    computed: {
      timerFormatted() {
        const minutes = parseInt(this.timer / 60)
        const seconds = parseInt(this.timer % 60)

        let m = minutes.toString()
        if (m.length === 1) {
          m = `0${m}`
        }

        let s = seconds.toString()
        if (s.length === 1) {
          s = `0${s}`
        }

        return `${m}:${s}`
      },
      radioAnswer: {
        get() {
          return this.answer
        },
        set(value) {
          this.$emit('change', value)
        }
      },
      ...mapState({
        ac: state => state.ac
      })
    }
  };
</script>

<style lang="scss" scoped>
  .auth-questions {}

  .auth-questions__timer {}

  .auth-questions__timer__display {
    display: block;
    margin: 14px 0 0 0;
    padding: 0;
    color: #003091;
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.875rem;
    line-height: normal;
    font-weight: 600;
  }

  .auth-questions--expired .auth-questions__timer__display {
    color: red;
  }

  .auth-questions--ac .auth-questions__timer__display {
    color: #FFFF00;
  }

  .auth-questions__paginator {
    padding: 22px 0;
  }

  .auth-questions__paginator__display {
    display: block;
    margin: 0;
    padding: 0;
    color: #808080;
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;
  }

  .auth-questions--ac .auth-questions__paginator__display {
    color: #FFFFFF;
  }

  .auth-questions__form {}

  .auth-questions__form__question {
    display: block;
    margin: 0;
    padding: 0;
    color: #181818;
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;
    font-weight: 500;
  }

  .auth-questions--ac .auth-questions__form__question {
    color: #FFFFFF;
  }

  .auth-questions__form__options {
    margin-top: 28px;
    margin-bottom: -17px;
  }

  .auth-questions__form__options__item {
    padding: 12px 0;
  }

  @media (min-width: 768px) {

    .auth-questions__form__question {
      font-size: 1.25rem;
    }
  }

</style>